export const AWS_REGION = 'eu-central-1';
export const AWS_USER_POOL_ID = 'eu-central-1_aiI08QVNo';
export const AWS_USER_POOL_WEB_CLIENT_ID = '31429dguao8t7q99dv2drjqenn';
export const AWS_IDENTITY_POOL_ID = 'eu-central-1:173d5eb1-23fd-44a2-b8f3-79bf40749a48';
export const BASE_URL = 'https://api.mercury.dev.ptcopilot.percix.ai';
export const CDN_BASE_URL = 'https://cdn.dev.ptcopilot.percix.ai/mercury';
export const RUM_APP_MONITOR_ID = '47c85c0a-1da7-4d5d-ba9e-b477e6729441';
// Mercury is single-region: no per-region monitor overrides.
export const RUM_MONITOR_BY_REGION: Record<string, string> = {};
export const SESSION_REPLAY_ENABLED = false;
// The published extension id, hardcoded. Chrome derives it from the
// signing key, so it is a permanent public constant, identical in
// every environment. Keep in sync with clinician-portal/src/
// externalConfig.ts and the extension's externally_connectable.
// A tester on an UNPACKED extension (different id) blanks this
// locally; see services/extensionId.ts for the DOM fallback.
export const PERCIX_EXTENSION_ID = 'jlnkfeodaagibopgjcaacdnifelmbnmk';
